import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-what-to-know-fast',
  imports: [TranslateModule],
  templateUrl: './what-to-know-fast.component.html',
  styleUrl: './what-to-know-fast.component.scss'
})
export class WhatToKnowFastComponent {

}
